/** Attribution reads fail by timing out when ClickHouse is busy, and a retry
 *  only adds to that load, so the error shows and the user can reload. */
export const ATTRIBUTION_QUERY_OPTIONS = { retry: false } as const;
